import { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ComicCard from "@/components/feature/ComicCard";
import BackToTop from "@/components/feature/BackToTop";
import { comics, categories } from "@/mocks/comics";

export default function Today() {
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "全部";
  const q = params.get("q") || "";

  const list = useMemo(() => {
    let result = [...comics].sort((a, b) => {
      const av = a.chapterList[0].no;
      const bv = b.chapterList[0].no;
      return bv - av;
    });
    if (cat !== "全部") result = result.filter((c) => c.category === cat);
    if (q) result = result.filter((c) => (c.title + c.tags.join("") + c.category).includes(q));
    return result;
  }, [cat, q]);

  const setCat = (c: string) => {
    const next = new URLSearchParams(params);
    next.set("cat", c);
    setParams(next);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [params]);

  return (
    <>
      <Seo
        title={cat === "全部" ? "卡通动漫第一页今日更新 - 每日最新上架漫画" : `卡通动漫第一页今日更新 - ${cat}分类`}
        description="卡通动漫第一页今日更新列表，每日刷新内容池，第一时间查看最新上架与连载作品，高分漫画与人气连载一页全收。"
        keywords="卡通动漫第一页今日更新,最新漫画,今日上架,连载更新"
      />
      <Navbar />

      <main className="bg-background-50 pt-16 md:pt-20">
        <div className="container-x">
          {/* 面包屑 */}
          <nav className="flex items-center gap-2 py-6 text-sm text-foreground-500" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-700 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line" style={{ fontSize: "16px" }}></i>
            <span className="text-foreground-800">今日更新</span>
          </nav>

          <div className="flex flex-col gap-2 border-b border-background-200 pb-6 md:flex-row md:items-end md:justify-between">
            <div>
              <h1 className="font-display text-3xl text-foreground-950">今日更新</h1>
              <p className="mt-1 text-sm text-foreground-500">每日刷新内容池，第一时间看到最新上架与连载作品</p>
            </div>
            <p className="text-sm text-foreground-600">共 {list.length} 部作品</p>
          </div>

          {/* 分类筛选 */}
          <div className="flex flex-wrap gap-2 py-5">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                className={`rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  cat === c ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700 ring-1 ring-background-200 hover:bg-background-200"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          {q && (
            <div className="mb-5 flex items-center gap-2 rounded-xl bg-accent-100 px-4 py-3 text-sm text-accent-900">
              <i className="ri-search-line" style={{ fontSize: "16px" }}></i>
              <span>正在搜索：“{q}”</span>
              <button
                onClick={() => setParams({})}
                className="ml-auto rounded-full bg-accent-200 px-3 py-1 text-xs hover:bg-accent-300 transition-colors"
              >
                清除搜索
              </button>
            </div>
          )}

          {list.length ? (
            <div className="grid grid-cols-2 gap-4 pb-14 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
              {list.map((c) => (
                <ComicCard key={c.id} comic={c} />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center gap-3 py-20 text-center">
              <i className="ri-inbox-line text-4xl text-foreground-300" style={{ fontSize: "40px" }}></i>
              <p className="text-sm text-foreground-500">暂时没有匹配的作品，换个分类或关键词试试吧</p>
              <button onClick={() => setParams({})} className="rounded-full bg-primary-500 px-5 py-2 text-sm text-background-50 hover:bg-primary-600 transition-colors">
                查看全部
              </button>
            </div>
          )}
        </div>
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}